import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import { useUserRole } from '@/hooks/useUserRole'
import { NotificationsProvider } from '@/context/NotificationsContext'
import { LoadingSpinner } from './LoadingSpinner'

export function AdminRoute() {
  const { user, loading: authLoading } = useAuth()
  const { isAdmin, loading: roleLoading } = useUserRole()
  const location = useLocation()

  if (authLoading || roleLoading) return <LoadingSpinner />
  if (!user) {
    const returnTo = `${location.pathname}${location.search}${location.hash}`
    return <Navigate to="/sign-in" replace state={{ returnTo }} />
  }
  if (!isAdmin) return <Navigate to="/" replace />

  return (
    <NotificationsProvider>
      <Outlet />
    </NotificationsProvider>
  )
}
